/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import type * as APITypes from '../API';

type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createVehicleLocation = /* GraphQL */ `mutation CreateVehicleLocation(
  $input: CreateVehicleLocationInput!
  $condition: ModelVehicleLocationConditionInput
) {
  createVehicleLocation(input: $input, condition: $condition) {
    vehicleId
    latitude
    longitude
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateVehicleLocationMutationVariables, APITypes.CreateVehicleLocationMutation>;
export const updateVehicleLocation = /* GraphQL */ `mutation UpdateVehicleLocation(
  $input: UpdateVehicleLocationInput!
  $condition: ModelVehicleLocationConditionInput
) {
  updateVehicleLocation(input: $input, condition: $condition) {
    vehicleId
    latitude
    longitude
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateVehicleLocationMutationVariables, APITypes.UpdateVehicleLocationMutation>;
export const deleteVehicleLocation = /* GraphQL */ `mutation DeleteVehicleLocation(
  $input: DeleteVehicleLocationInput!
  $condition: ModelVehicleLocationConditionInput
) {
  deleteVehicleLocation(input: $input, condition: $condition) {
    vehicleId
    latitude
    longitude
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteVehicleLocationMutationVariables, APITypes.DeleteVehicleLocationMutation>;
export const createReservationStatus = /* GraphQL */ `mutation CreateReservationStatus(
  $input: CreateReservationStatusInput!
  $condition: ModelReservationStatusConditionInput
) {
  createReservationStatus(input: $input, condition: $condition) {
    reservationId
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.CreateReservationStatusMutationVariables, APITypes.CreateReservationStatusMutation>;
export const updateReservationStatus = /* GraphQL */ `mutation UpdateReservationStatus(
  $input: UpdateReservationStatusInput!
  $condition: ModelReservationStatusConditionInput
) {
  updateReservationStatus(input: $input, condition: $condition) {
    reservationId
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UpdateReservationStatusMutationVariables, APITypes.UpdateReservationStatusMutation>;
export const deleteReservationStatus = /* GraphQL */ `mutation DeleteReservationStatus(
  $input: DeleteReservationStatusInput!
  $condition: ModelReservationStatusConditionInput
) {
  deleteReservationStatus(input: $input, condition: $condition) {
    reservationId
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.DeleteReservationStatusMutationVariables, APITypes.DeleteReservationStatusMutation>;
export const createDriverIndividualNotification = /* GraphQL */ `mutation CreateDriverIndividualNotification(
  $input: CreateDriverIndividualNotificationInput!
  $condition: ModelDriverIndividualNotificationConditionInput
) {
  createDriverIndividualNotification(input: $input, condition: $condition) {
    driverId
    createdAt
    subject
    body
    eventId
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDriverIndividualNotificationMutationVariables,
  APITypes.CreateDriverIndividualNotificationMutation
>;
export const updateDriverIndividualNotification = /* GraphQL */ `mutation UpdateDriverIndividualNotification(
  $input: UpdateDriverIndividualNotificationInput!
  $condition: ModelDriverIndividualNotificationConditionInput
) {
  updateDriverIndividualNotification(input: $input, condition: $condition) {
    driverId
    createdAt
    subject
    body
    eventId
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDriverIndividualNotificationMutationVariables,
  APITypes.UpdateDriverIndividualNotificationMutation
>;
export const deleteDriverIndividualNotification = /* GraphQL */ `mutation DeleteDriverIndividualNotification(
  $input: DeleteDriverIndividualNotificationInput!
  $condition: ModelDriverIndividualNotificationConditionInput
) {
  deleteDriverIndividualNotification(input: $input, condition: $condition) {
    driverId
    createdAt
    subject
    body
    eventId
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDriverIndividualNotificationMutationVariables,
  APITypes.DeleteDriverIndividualNotificationMutation
>;
export const createVehicleOperationScheduleUpdateManagement =
  /* GraphQL */ `mutation CreateVehicleOperationScheduleUpdateManagement(
  $input: CreateVehicleOperationScheduleUpdateManagementInput!
  $condition: ModelVehicleOperationScheduleUpdateManagementConditionInput
) {
  createVehicleOperationScheduleUpdateManagement(
    input: $input
    condition: $condition
  ) {
    vehicleId
    firstVehicleOperationScheduleId
    operationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateVehicleOperationScheduleUpdateManagementMutationVariables,
    APITypes.CreateVehicleOperationScheduleUpdateManagementMutation
  >;
export const updateVehicleOperationScheduleUpdateManagement =
  /* GraphQL */ `mutation UpdateVehicleOperationScheduleUpdateManagement(
  $input: UpdateVehicleOperationScheduleUpdateManagementInput!
  $condition: ModelVehicleOperationScheduleUpdateManagementConditionInput
) {
  updateVehicleOperationScheduleUpdateManagement(
    input: $input
    condition: $condition
  ) {
    vehicleId
    firstVehicleOperationScheduleId
    operationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UpdateVehicleOperationScheduleUpdateManagementMutationVariables,
    APITypes.UpdateVehicleOperationScheduleUpdateManagementMutation
  >;
export const deleteVehicleOperationScheduleUpdateManagement =
  /* GraphQL */ `mutation DeleteVehicleOperationScheduleUpdateManagement(
  $input: DeleteVehicleOperationScheduleUpdateManagementInput!
  $condition: ModelVehicleOperationScheduleUpdateManagementConditionInput
) {
  deleteVehicleOperationScheduleUpdateManagement(
    input: $input
    condition: $condition
  ) {
    vehicleId
    firstVehicleOperationScheduleId
    operationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.DeleteVehicleOperationScheduleUpdateManagementMutationVariables,
    APITypes.DeleteVehicleOperationScheduleUpdateManagementMutation
  >;
export const createMobiPFUserTransactionInformation = /* GraphQL */ `mutation CreateMobiPFUserTransactionInformation(
  $input: CreateMobiPFUserTransactionInformationInput!
  $condition: ModelMobiPFUserTransactionInformationConditionInput
) {
  createMobiPFUserTransactionInformation(input: $input, condition: $condition) {
    orderId
    userId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMobiPFUserTransactionInformationMutationVariables,
  APITypes.CreateMobiPFUserTransactionInformationMutation
>;
export const updateMobiPFUserTransactionInformation = /* GraphQL */ `mutation UpdateMobiPFUserTransactionInformation(
  $input: UpdateMobiPFUserTransactionInformationInput!
  $condition: ModelMobiPFUserTransactionInformationConditionInput
) {
  updateMobiPFUserTransactionInformation(input: $input, condition: $condition) {
    orderId
    userId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMobiPFUserTransactionInformationMutationVariables,
  APITypes.UpdateMobiPFUserTransactionInformationMutation
>;
export const deleteMobiPFUserTransactionInformation = /* GraphQL */ `mutation DeleteMobiPFUserTransactionInformation(
  $input: DeleteMobiPFUserTransactionInformationInput!
  $condition: ModelMobiPFUserTransactionInformationConditionInput
) {
  deleteMobiPFUserTransactionInformation(input: $input, condition: $condition) {
    orderId
    userId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMobiPFUserTransactionInformationMutationVariables,
  APITypes.DeleteMobiPFUserTransactionInformationMutation
>;
